module.exports = __webpack_public_path__ + "fonts/SegoeUI.61bb848e.ttf";